import Vue from 'vue';
import Router from 'vue-router';

import user from '../components/user.vue';
import certificate from '../components/certificate.vue';
import index from '../components/index.vue';
import home from '../components/home.vue';
import exam from '../components/exam.vue';
import order from '../components/order.vue';
import renewal from "../components/renewal.vue";
import cpeActivity from "../components/cpeActivity.vue";
import cpePolicy from "../components/cpePolicy.vue";
import cpeApply from "../components/cpeApply.vue";
import activityImprovement from "../components/activityImprovement.vue";

const findPassword = () => import('../components/find-password.vue');

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/',
            component: index,
            children: [
                {
                    path: '/home',
                    component: home
                },
                {
                    path: '/user',
                    component: user,
                    meta: {
                        requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/certificate',
                    component: certificate
                },
                {
                    path: '/exam',
                    component: exam,
                    meta: {
                        requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/order',
                    component: order,
                    meta: {
                        requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/renewal',
                    component: renewal,
                    meta: {
                        requireAuth: false // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/cpeApply',
                    component: cpeApply,
                    meta: {
                        requireAuth: false // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/cpeActivity',
                    component: cpeActivity,
                    meta: {
                        requireAuth: false // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/cpePolicy',
                    component: cpePolicy,
                    meta: {
                        requireAuth: false // 添加该字段，表示进入这个路由是需要登录才能进入的
                    }
                },
                {
                    path: '/activityImprovement',
                    component: activityImprovement,
                    meta: {
                        requireAuth: false
                    }
                }
            ]
        },
        {
            path: '/findPassword',
            component: findPassword
        }
    ]
})


